import ConfirmModal from '@/components/ConfirmModal';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { updateDesks } from '@/services/desk.service';
import { addZone } from '@/services/zone.service';
import { format } from 'date-fns';
import { title } from 'process';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
  Button,
  DateRangePicker,
  Drawer,
  Form,
  InputPicker,
  Message,
  Schema,
  SelectPicker,
  TagPicker,
  Toggle,
  useToaster
} from 'rsuite';

const { ArrayType, StringType } = Schema.Types;
const model = Schema.Model({
  desks: ArrayType().isRequired('This field is required.'),
  zone: StringType().isRequired('This field is required.')
});
const BlockDrawer = ({ open, onClose, selectedDesks, setSelectedDesks, floor }) => {
  const dispatch = useAppDispatch();
  const [formValue, setFormValue] = useState({ desks: selectedDesks });
  const [confirmModal, setConfirmModel] = useState<any>({ open: false });
  const toaster = useToaster();
  const desks = useAppSelector((state: any) => state.desk.data).map(item => ({
    ...item,
    value: item._id,
    label: item.name
  }));

  const zones = useAppSelector((state: any) => state.zone.data).map(item => ({
    ...item,
    value: item._id,
    label: item.name
  }));

  const handleClose = () => {
    setFormValue({});
    onClose();
  };

  console.log('formValue', formValue);
  const handleSubmit = async () => {
    let hasErrors = false;

    console.log('formValue', formValue);

    const errors = model.check(formValue);

    console.log('errors', errors);

    Object.entries(errors).forEach(([field, error]) => {
      if (error.hasError) {
        hasErrors = true;

        return;
      }
    });

    if (hasErrors) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {`Fill required fields`}
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    console.log('formValue', formValue);
    dispatch(updateDesks(formValue, floor._id))
      .then(() => {
        toaster.push(
          <Message type="success" duration={5000} showIcon>
            {t('Updated successfully')}
          </Message>,
          { placement: 'topCenter' }
        );
        setSelectedDesks([]);
        onClose();
      })
      .catch(e => {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            {e}
          </Message>,
          { placement: 'topCenter' }
        );
      });
  };

  const handleAddZone = async data => {
    console.log('zone to add with data:', data);
    dispatch(addZone(data))
      .then(response => {
        toaster.push(
          <Message type="success" duration={5000} showIcon>
            {t('Zone added successfully')}
          </Message>,
          { placement: 'topCenter' }
        );
        setConfirmModel({ open: false });
        setFormValue(prevFormValue => ({ ...prevFormValue, zone: response.data._id }));
      })
      .catch(e => {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            {e}
          </Message>,
          { placement: 'topCenter' }
        );
      });
  };

  console.log('formValue', formValue);
  const { t } = useTranslation();
  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Block/Unblock resources')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Save')}
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue} model={model}>
          <Form.Group>
            <Form.ControlLabel>{t('Resources')}</Form.ControlLabel>
            <Form.Control
              name="desks"
              accepter={TagPicker}
              data={desks}
              searchable={true}
              placeholder={t("Select resources")}
              block
              value={selectedDesks}
              onChange={setSelectedDesks}
              placement="auto"
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>{t('Status')}</Form.ControlLabel>
            <Form.Control
              name="status"
              accepter={Toggle}
              size="lg"
              checkedChildren="Available"
              unCheckedChildren="Blocked"
              checked={formValue?.status == 'AVAILABLE' ? true : false}
              onChange={checked => {
                setFormValue(prevFormValue => ({
                  ...prevFormValue,
                  status: checked ? 'AVAILABLE' : 'BLOCK'
                }));
              }}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Period')}</Form.ControlLabel>
            <Form.Control
              name=""
              accepter={DateRangePicker}
              size="lg"
              onChange={val => {
                console.log('val', val);
                setFormValue(prevFormValue => ({
                  ...prevFormValue,
                  startDate: format(val[0], 'yyyy-MM-dd'),
                  endDate: format(val[1], 'yyyy-MM-dd')
                }));
              }}
              placement="auto"
            />
          </Form.Group>
        </Form>
      </Drawer.Body>

      {confirmModal.open && (
        <ConfirmModal confirmDialog={confirmModal} setConfirmDialog={setConfirmModel} />
      )}
    </Drawer>
  );
};

export default BlockDrawer;
